import { Directive, Output, EventEmitter, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
    selector: '[finderElementChange]',
    standalone: true
})
export class ElementChangeDirective implements AfterViewInit, OnDestroy {

    @Output() public finderElementChange = new EventEmitter();

    private changes: MutationObserver;

    constructor(
        private elementRef: ElementRef
    ) { }

    ngAfterViewInit() {
        const element = this.elementRef.nativeElement;
        // Couldn't find a way to trigger this in a test
        /* istanbul ignore next */
        this.changes = new MutationObserver(() => {
            this.finderElementChange.emit(element);
        });

        this.changes.observe(element, {
            attributes: true,
            childList: true,
        });
    }

    ngOnDestroy() {
        this.changes.disconnect();
    }
}
